import { render, staticRenderFns } from "./CargoFormComponent.vue?vue&type=template&id=247e4fc2&"
import script from "./CargoFormComponent.vue?vue&type=script&lang=js&"
export * from "./CargoFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./CargoFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports